module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/9-active-e75c0b944f82082ae0cc5fe4e2550291.png";